type ReplyPublishLabelDict = {
  publishing?: string;
  publishingAt?: string;
  publishingSoon?: string;
};

/** Label for a reply that is queued for publish (badge / button). */
export function formatScheduledPublishLabel(
  publishDueAt: string | null | undefined,
  locale: string,
  dict?: ReplyPublishLabelDict,
): string {
  const fallbackPublishing = dict?.publishing ?? 'Publishing…';
  if (!publishDueAt) return fallbackPublishing;

  const dueMs = new Date(publishDueAt).getTime();
  if (!Number.isFinite(dueMs)) return fallbackPublishing;

  const now = Date.now();
  if (dueMs <= now + 90_000) {
    return dict?.publishingSoon ?? fallbackPublishing;
  }

  const timeStr = new Date(publishDueAt).toLocaleString(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
  });
  const template = dict?.publishingAt ?? 'Publishing at {time}';
  return template.replace('{time}', timeStr);
}
